import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { Grid, Button } from '@material-ui/core'
import OnEvent from 'react-onevent'

// action

import { resetPassword } from '../actions/auth'

// local files

import ModifiedTextInput from '../components/common/ModifiedTextInput'
import ContainerWithTitle from '../containers/HOC/ContainerWithTitle'
import SideCoverHOC from './SideCover'
import { isValidString } from '../utils/string'
import { openErrorMessage } from '../actions/message'

class Reset extends PureComponent {
  state = {
    email: '',
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  onSubmit = () => {
    const { email } = this.state

    if (!isValidString(email)) {
      return this.props.dispatch(openErrorMessage('Email is required'))
    }

    this.props
      .dispatch(
        resetPassword({
          email,
        }),
      )
      .then(() => {
        this.props.history.push('/login')
      })
  }

  render() {
    const { email } = this.state

    return (
      <OnEvent enter={this.onSubmit}>
        <Grid className="rightBlockLogin" item xs={11} sm={7} md={11} lg={7}>
          <div>
            <h1 className="big-header slim-heading">Reset</h1>
          </div>
          <ModifiedTextInput
            id="name"
            placeholder="Email"
            margin="normal"
            className="margin-top-medium"
            onChange={this.onChange}
            value={email}
            name="email"
          />
          <div className="vertical-middle margin-top-small">
            <Link className="black-link" to="/">
              Back to login
            </Link>
          </div>
          <div className="margin-top-medium">
            <Button onClick={this.onSubmit} className="float-right" id="login-button">
              Reset
            </Button>
          </div>
        </Grid>
      </OnEvent>
    )
  }
}

export default connect((state) => ({
  authReducer: state.authReducer,
  dispatch: state.dispatch,
}))(SideCoverHOC(ContainerWithTitle(Reset, 'Reset password')))



// WEBPACK FOOTER //
// ./src/containers/Reset.js